import Tether from 'tether';

class ArticleShare {

    constructor() {

        this.el = document.querySelector('.js-article-share');
        this.anchorEl = document.querySelector('.js-article-share-anchor');

        if (!this.el) {
            return;
        }

        const tetherOptions = {
            element: this.el,
            target: this.anchorEl,
            attachment: 'top left',
            targetAttachment: 'top left',
            targetModifier: 'visible',
            constraints: [
                {
                    to: this.anchorEl,
                    pin: ['bottom'],
                },
            ],
        };

        this.tether = new Tether(tetherOptions);
    }
}

// eslint-disable-next-line
new ArticleShare();
